import { ReactNode } from 'react';

interface HeaderProps {
  title: string;
  subtitle?: string;
  right?: ReactNode;
  onBack?: () => void;
}

/** Header comun para todas las paginas de modulo. */
export function Header({ title, subtitle, right, onBack }: HeaderProps) {
  return (
    <header className="safe-top sticky top-0 z-20 border-b border-ink-100 bg-surface/90 px-4 py-3.5 backdrop-blur">
      <div className="flex items-center gap-3">
        {onBack && (
          <button onClick={onBack} className="flex h-10 w-10 items-center justify-center rounded-xl hover:bg-ink-50" aria-label="Volver">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>
        )}
        <div className="min-w-0 flex-1">
          <h1 className="truncate text-lg font-bold text-ink-900">{title}</h1>
          {subtitle && <p className="truncate text-xs text-ink-400">{subtitle}</p>}
        </div>
        {right}
      </div>
    </header>
  );
}
